export const DOC_FLOW_SCOPE_BUILDINGS_FIELD_QA_NAME = 'docFlowScopeBuildings'
